import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

const ENDPOINTS = {
    TASK_DETAILS :"api/Task/v1/TaskDetails",
    TASK_DETAILS_ASSIGNED:"api/Task/v1/TaskDetailsAssignedByMe",
    TASK_OWNER :"api/Task/v1/TaskOwners",
    TASK_STATUS:"api/Task/v1/TaskStatus",
    TASK_DETAIL:"api/Task/v1/TaskDetails",
    UNDO_TASK:"api/Task/v1/UndoTask",
    DELETE_TASK:"api/Task/DeleteTask?taskId=",
    TASK_COMMENT:"api/Task/GetTaskComments",
    COMMENT :"api/Task/CommentOnTask",
    EXCEL:"api/Task/v1/Export?isMyTask=",
    COMPANY_MEMBERS:"api/CompanyMembers",
    ADD_TASK:"api/Task/v1/AddTask",
    UPLOAD_DOC :"api/Task/v1/TaskDocument",
    UPDATE_TASK:"api/Task/v1/UpdateTask",
}

const getTaskDetails = async (data:any):Promise<ApiResponse<any>>=>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.TASK_DETAILS,data
        )
        return res.data;
}
const getTaskAssignedByMe = async (data:any):Promise<ApiResponse<any>>=>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.TASK_DETAILS_ASSIGNED,data
        )
        return res.data;
}
const getTaskOwners = async (data:any):Promise<ApiResponse<any>>=>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.TASK_OWNER,data
        )
        return res.data;
}

const updateTaskStatus = async (data:any):Promise<ApiResponse<any>> =>{
        const res =await privateRequest.put<ApiResponse<any>>(
           `${ENDPOINTS.TASK_STATUS}?taskId=${data.taskId}`,data.payload
        )
        return res.data;
}

const getTaskDetailById = async (taskId: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.TASK_DETAIL}/${taskId}`
    );
    return res.data;
};
 
const undoTask = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(
        `${ENDPOINTS.UNDO_TASK}?taskId=${data.taskId}&isMyTask=${data.isMyTask}`,data.payload
    );
    return res.data;
}

const deleteTask = async (taskId: any): Promise<ApiResponse<any>> => {  
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.DELETE_TASK}${taskId}`
    );
    return res.data;
}

const getTaskComment = async (data:any):Promise<ApiResponse<any>> =>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.TASK_COMMENT ,data
        )
    return res.data;
}

const commentOnTask = async (data:any):Promise<ApiResponse<any>> =>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.COMMENT ,data
        )
    return res.data;
}

const exportTask = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.EXCEL}${data.isMyTask}`,data.params,{
            responseType: "arraybuffer"
        }
    );
    saveAsExcelFile(res, data.isMyTask ? "Assigned_To_Me_Task" : "Assigned_By_Me_Task" , true);
}   

const getCompanyMembers = async (data:any):Promise<ApiResponse<any>> => {

        const res = await privateRequest.get<ApiResponse<any>>(
            `${ENDPOINTS.COMPANY_MEMBERS}?from=${data.from}&text=${data.text}&to=${data.to}`
        )
        
        return res.data;
}

const addTask  = async (data:any):Promise<ApiResponse<any>> =>{
        const res = await privateRequest.post<ApiResponse<any>>(
                ENDPOINTS.ADD_TASK,data
        )
        return res.data;
}

const taskDocumentUpload = async(data:any):Promise<ApiResponse<any>> => {
    const formData = new FormData();
    if(data.selectedFile){
        formData.append("docs",data.selectedFile);
    }
    const res =await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.UPLOAD_DOC}/${data.taskId}?imageId=${data.imageId}`,formData
    )
    return res.data;
}

const updateTask = async(data:any):Promise<ApiResponse<any>> =>{
        const res = await privateRequest.put<ApiResponse<any>>(
                ENDPOINTS.UPDATE_TASK,data
        )
        return res.data;
}

const myTaskService = {
    getTaskDetails,
    getTaskAssignedByMe,
    getTaskOwners,
    updateTaskStatus,
    getTaskDetailById,
    undoTask,
    deleteTask,
    getTaskComment,
    commentOnTask,
    exportTask,
    getCompanyMembers,
    addTask,
    taskDocumentUpload,
    updateTask
}

export default myTaskService;
